import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  ExtendedOrganisationListItem,
  ExtendedWorkspaceListItem
} from '@futrli/views/operations/workspaces/processors/workspacesList';
import { Organisation } from '@futrli-sdk/organisations';
import { OrganisationUploadDrawer } from '@futrli/shared-services/excel-upload/excel-modals/upload/organisation-upload-drawer';
import { UpdateFromExcelModalContent } from '@futrli/shared-services/excel-upload';

interface UpdateValuesDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  organisation: ExtendedOrganisationListItem;
  workspace: ExtendedWorkspaceListItem;
}

export const UpdateValuesDrawer = ({ isOpen, onClose, organisation, workspace }: UpdateValuesDrawerProps) => {
  if (!organisation.integration || !organisation.datasource?.id) {
    return null;
  }

  return (
    <OrganisationUploadDrawer
      title={
        <FormattedMessage
          id="predict.update_excel_data_for_name"
          defaultMessage="Update the excel data for {orgName}"
          values={{ orgName: organisation.name }}
        />
      }
      isOpen={isOpen}
      handleClose={onClose}
      workspaceId={workspace.id}
      excelIntegration={organisation.integration}
      organisation={(organisation as unknown) as Organisation}
      isUpdateDrawer
    >
      <UpdateFromExcelModalContent
        workspaceId={workspace.id}
        organisationId={organisation.id}
        config={{ entityType: 'organisation' }}
        guidelinesUrl="https://support.futrli.com/en/articles/10485548-excel-organisations"
      />
    </OrganisationUploadDrawer>
  );
};
